/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DxpRoleName } from '@squiz/dxp-auth';
import { EntityDxpUserMeBaseTenant } from '../../Services/console';
import { getUserRolesInTenant } from '../GetUserRolesInTenant/GetUserRolesInTenant';
import { HeapEventProperties } from './SetHeapEventProperties.defs';

/**
 * Set the Heap event properties based on provided tenant.
 */
export function setHeapEventProperties(tenant?: EntityDxpUserMeBaseTenant): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const heap = (window as any).heap;

  // Always set this property, even outside a tenant
  const customProperties: HeapEventProperties = {
    'DXP - Product': 'sxc',
  };

  // Add these extra properties when events are triggered within a tenant
  if (tenant) {
    const { tenantName, tenantReferenceId, tenantRegion } = tenant;

    const roles = getUserRolesInTenant(tenantReferenceId)
      .map((roleId) => DxpRoleName[roleId])
      .join(', ');

    customProperties['DXP - Instance - Region'] = tenantRegion;
    customProperties['DXP - Roles'] = roles;
    customProperties['DXP - Tenant'] = tenantName;
    customProperties['DXP - Tenant ID'] = tenantReferenceId;
  }

  // Set the event properties
  if (heap) {
    heap.clearEventProperties();
    heap.addEventProperties(customProperties);
  }
}
